import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Utilitário para formatação de números sem cifrão
export const formatNumber = (value: number): string => {
  return new Intl.NumberFormat("pt-BR", { 
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2 
  }).format(Math.abs(value));
};

// Utilitário para obter a classe CSS baseada no valor (positivo/negativo)
export const getValueColorClass = (value: number): string => {
  return value >= 0 ? "text-success" : "text-destructive";
};

// Utilitário para formatação com sinal
export const formatNumberWithSign = (value: number): string => {
  const sign = value >= 0 ? "" : "-";
  return sign + formatNumber(value);
};
